import { Component, OnInit } from '@angular/core';
import { TokenStorageService } from './core/_services/token-storage.service';


@Component({
    selector: 'lse-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent{
  title = 'LSS-Event';
}
